<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <div  class="div-query-banner"  >
          <a-form-item label="投诉人姓名">
            <j-input  v-model="queryParam.userName"   />
          </a-form-item>
          <a-form-item label="被投诉人姓名">
            <j-input   v-model="queryParam.targetUserName"    />
          </a-form-item>
          <a-button  class="query-banner-btn" type="primary" @click="searchQuery" icon="search">查询</a-button>
          <a-button  class="query-banner-btn" type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
        </div>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('巡检投诉表')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" >
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        
        @change="handleTableChange">
         <template slot="imgSlot" slot-scope="text, record,index">
          <a  @click="onShowPicture(text,record,index);" >查看图片</a>
        </template>
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">详情</a>

          <!-- <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </span>

      </a-table>
    </div>
    <div class="images" v-viewer="{movable: false}"    >
      <img v-show="false" v-for='item in imageListData' :src="item" :key="item">
    </div>
    <complaint-modal ref="modalForm" @ok="modalFormOk"></complaint-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import ComplaintModal from './modules/ComplaintModal'
  import { getAction,postAction } from '@/api/manage'
  import JInput from '@/components/jeecg/JInput'
  export default {
    name: "BusInspectionComplaintList",
    mixins:[JeecgListMixin],
    components: {
      ComplaintModal,JInput
    },
    data () {
      return {
        description: '巡检投诉表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
           {
            title:'投诉人名字',
            align:"center",
            dataIndex: 'complaintUserName'
          },
          {
            title:'被投诉人姓名',
            align:"center",
            dataIndex: 'complaintTargetUserName'
          },
          {
            title:'投诉原因',
            align:"center",
            dataIndex: 'complaintRemarks'
          },
          {
            title:'对应巡查时间',
            align:"center",
            dataIndex: 'exceptionCreateTime'
          },
          {
            title:'对应异常描述',
            align:"center",
            dataIndex: 'exceptionRemarks'
          },
          {
            title:'对应异常图片',
            align:"center",
            scopedSlots:{
              customRender:"imgSlot"
            },
            width:"120px",
          },
          // {
          //   title: '操作',
          //   dataIndex: 'action',
          //   align:"center",
          //   scopedSlots: { customRender: 'action' }
          // }
        ],
        url: {
          list: "/general/complaint/busInspectionComplaint/list",
          delete: "/general/complaint/busInspectionComplaint/delete",
          deleteBatch: "/general/complaint/busInspectionComplaint/deleteBatch",
          exportXlsUrl: "/general/complaint/busInspectionComplaint/exportXls",
          importExcelUrl: "general/complaint/busInspectionComplaint/importExcel",
        },
        dictOptions:{},
        imageListData:[]
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      async onShowPicture(text,record,index){
        let params={
          orderId:record.taskDetailId,
          fileType:"image",
        }
        let pictureData=await  postAction("/general/inspection/api/file/findFileList",params)
        if(pictureData.result.length==0){
          this.$message.success("暂无图片")
          return
        }
        this.imageListData=[]
        pictureData.result.forEach(item=>{
          this.imageListData.push(item.fileUrl)
        })
        const viewer = this.$el.querySelector('.images').$viewer
        viewer.show()  
      },
      initDictConfig(){
      },
      loadData (arg) {
        if (!this.url.list) {
            this.$message.error("请设置url.list属性!")
            return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
            this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        this.loading = true;
        this.dataSource=[]
        getAction(this.url.list, params).then((res) => {
            if (res.success) {
                this.dataSource = res.result.records.map((item)=>{
                  return {
                    complaintCreateTime: item.createTime,
                    id: item.id,
                    improveId: item.improveId,
                    complaintRemarks: item.remarks,
                    complaintTargetUserName: item.targetUserName,
                    complaintTargetUserNo: item.targetUserNo,
                    taskDetailId: item.taskDetailId,
                    complaintUserName: item.userName,
                    exceptionCreateTime:item.busInspectionTaskDetail.createTime,
                    exceptionId: item.busInspectionTaskDetail.id,
                    exceptionRemarks: item.busInspectionTaskDetail.remarks,
                    exceptionStatus: item.busInspectionTaskDetail.status,
                    taskId: item.busInspectionTaskDetail.taskId,
                  }
                });
                this.ipagination.total = res.result.total;
                this.pageRefresh ++
            }else{
                this.$message.warning(res.message)
            }  
            if (res.code === 510) {
                this.$message.warning(res.message)
            }
            this.loading = false;
        })
    },
    }
  }
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
  .div-query-banner{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    & >*:nth-child(n){
      width:300px;
      
    }
    &>*:nth-child(n+2){
      margin-left: 12px;
    }
    &>.query-banner-btn:nth-child(n){
      width:100px
    }
  }
</style>